module.exports = __webpack_public_path__ + "img/1440.4d32daf7.jpg";